import styles from './ToggleSwitch.module.scss'
import { motion } from 'framer-motion'
import { useContext, useState } from 'react'
import OptionsContext from '../../utils/OptionsContext'

const ToggleSwitch = ({ isOn , handleToggle, switchType }) => {
  const [animate, setAnimate] = useState()
  const [transition, setTransition] = useState()

  const { shouldReduceMotion } = useContext(OptionsContext).options
 
  function handleChange() {
    setAnimate({ x: isOn ? 0 : 25 })
    setTransition({ duration: shouldReduceMotion ? 0 : .1 })
    handleToggle()
  }

  return (
    <div className={styles.toggleSwitchWrapper}>
      <input
        checked={isOn || ''}
        onChange={handleChange}
        className={`sr-only ${styles.switchCheckbox}`}
        id={switchType}
        type='checkbox'
      />
      <label
        className={styles.switchLabel}
        htmlFor={switchType}
      >
        <motion.span 
          className={styles.switchBall}
          initial={{ x: isOn ? 25 : 0 }} 
          animate={animate}
          transition={transition}
        />
      </label>
      
    </div> 
  )
}

export default ToggleSwitch